import Vue from 'vue'
import Vuex from 'vuex'
import Constant from '../common/common-constant'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    lang: Constant.DEFAULT_LANGUAGE,
    ruleFirstLoad: true,
    ruleReadonly: false,
    isLoading: false
  },
  getters: {
    getLang: state => state.lang,
    getLoading: state => state.isLoading,
    isRuleFirstLoad: state => state.ruleFirstLoad,
    isRuleReadonly: state => state.ruleReadonly
  },
  mutations: {
    SET_LANG: (state, payload) => {
      payload.context.$i18n._vm.locale = payload.lang
      state.lang = payload.lang
    },
    SET_LOADING: (state, isLoading) => {
      state.isLoading = isLoading
    },
    SET_RULE_FIRST_LOAD: (state, ruleFirstLoad) => {
      state.ruleFirstLoad = ruleFirstLoad
    },
    SET_RULE_READONLY: (state, ruleReadonly) => {
      state.ruleReadonly = ruleReadonly
    }
  },
  actions: {
    setLang ({ commit }, payload) {
      commit('SET_LANG', payload)
    },
    setLoading ({ commit }, isLoading) {
      commit('SET_LOADING', isLoading)
    },
    setRuleFirstLoad ({ commit }, state) {
      commit('SET_RULE_FIRST_LOAD', state)
    },
    setRuleReadonly ({ commit }, state) {
      commit('SET_RULE_READONLY', state)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js